import React, { useState } from "react"
import PrivacyPolicyModal from "./Modals/PrivacyPolicyModal"
import TermsOfServiceModal from "./Modals/TermsOfServiceModal"
import { translations } from "../../utils/Translation/staticTranslation"
import "./Modals/privacypolicy.css"

const LegalLinks = ({ className = "" }) => {
  const lang = localStorage.getItem("language") || "ar"
  const privacyData = translations[lang]?.privacy_policy
  const loginPage = translations[lang]?.loginPage
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false)
  const [isTermsOpen, setIsTermsOpen] = useState(false)

  return (
    <>
      <div className={`legal-footer-links ${className}`.trim()}>
        <button
          type="button"
          className="privacy-policy-btn"
          onClick={() => setIsTermsOpen(true)}
        >
          {loginPage?.terms_of_service}
        </button>
        <span className="legal-footer-separator">
          {lang === "ar" ? "و" : "|"}
        </span>
        <button
          type="button"
          className="privacy-policy-btn"
          onClick={() => setIsPrivacyOpen(true)}
        >
          {privacyData?.Privacy_policy}
        </button>
      </div>

      <PrivacyPolicyModal
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
        translations={translations}
        currentLang={lang}
      />

      <TermsOfServiceModal
        isOpen={isTermsOpen}
        onClose={() => setIsTermsOpen(false)}
        translations={translations}
        currentLang={lang}
      />
    </>
  )
}

export default LegalLinks
